import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SHOPPING_CART_SUMMARY_TOTAL_TITLE_CLASS_NAME } from '../../theme/constants/typography';

const useShoppingCartSummaryChile = (shoppingCartData) => {
  const { t } = useTranslation();

  const formattedShoppingCart = useMemo(() => {
    const shoppingCartArray = [
      {
        title: 'Cantidad de facturas',
        subtitle: '',
        value: shoppingCartData?.invoiceCount,
        money: false,
      },
      {
        title: 'Monto total',
        subtitle: '',
        value: shoppingCartData?.totalAmount,
        money: true,
      },
      {
        title: t('financed amount', {
          percentage: shoppingCartData?.retentionRate != null ? (100 - shoppingCartData.retentionRate) : '',
        }),
        subtitle: '',
        value: shoppingCartData?.financedAmount,
        money: true,
        discount: true,
      },
      {
        title: t('total costs'),
        titleVariant: 'small_3',
        expandable: true,
        subtitle: '',
        value: shoppingCartData?.totalCosts,
        money: true,
      },
      {
        title: t('reference rate'),
        subtitle: '',
        value: shoppingCartData?.rate,
        isChild: true,
        money: false,
      },
      {
        title: t('Price difference'),
        subtitle: '',
        value: shoppingCartData?.priceDifference,
        isChild: true,
        money: true,
        discount: true,
      },
      {
        title: 'Comisión',
        subtitle: '',
        value: shoppingCartData?.commission,
        isChild: true,
        money: true,
        divider: true,
      },
      {
        title: 'Total a depositar',
        titleVariant: 'small_3',
        titleClassName: SHOPPING_CART_SUMMARY_TOTAL_TITLE_CLASS_NAME,
        valueVariant: 'medium_1',
        subtitle: 'En base a simulación a 30 días.', // TODO: Este atributo no se utiliza en el nuevo summary data,
        //  pero aun se usa en el carrito. Eliminar cuando se elimine el carrito.
        value: shoppingCartData?.depositAmount,
        money: true,
        color: 'text.highlight',
      },
    ];

    if (shoppingCartData?.orderingDebt > 0) {
      shoppingCartArray.push({
        title: 'Descuento de Ordering',
        value: (shoppingCartData?.orderingDebt || 0) * -1,
        money: true,
      });
    }

    if (shoppingCartData?.negativeSurplus?.amount > 0) {
      shoppingCartArray.splice(7, 0, {
        title: 'Cobro por mora acumulada',
        value: shoppingCartData?.negativeSurplus,
        money: true,
      });
    }

    return shoppingCartArray;
  }, [shoppingCartData, t]);

  return formattedShoppingCart;
};

export default useShoppingCartSummaryChile;
